import { render, staticRenderFns } from "./applicant-avatar.vue?vue&type=template&id=eb5878ec"
import script from "./applicant-avatar.vue?vue&type=script&lang=js"
export * from "./applicant-avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports